/**
 * Shared filter submit chrome. Wrap fields in FilterForm so Enter and
 * Apply filters always run the same handler (do not disable Apply just
 * because draft === applied — that looks broken when fields are empty).
 */
export function FilterForm({ onApply, disabled = false, className = '', children }) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (!disabled) onApply();
      }}
      className={className}
    >
      {children}
    </form>
  );
}

export default function FilterToolbar({
  onClear,
  hasActiveFilters,
  disabled = false,
  extra,
  children,
  className = '',
}) {
  return (
    <div className={`flex flex-wrap items-center justify-end gap-2 ${className}`}>
      {children}
      {extra}
      <button type="submit" className="btn-primary py-1.5 text-sm" disabled={disabled}>
        Apply filters
      </button>
      {hasActiveFilters && (
        <button type="button" onClick={onClear} className="btn-secondary py-1.5 text-sm">
          Clear all
        </button>
      )}
    </div>
  );
}
